export class DocumentManagerObj {
  public documentManagerId: Number;
  public documentType: String = '';
  public documentName: String = '';
  public dateCreated: Date;
  public dateLastUploaded: Date;
  public effectiveDate: Date;
  public expiryDate: Date;
  public customerType: String = '';
  public userID: Number;
  public fileName: String = '';
  public carrierId: Number;
  public adminOnlyFlag: Number = 0;
  public additionalComments: String = '';
  public organizationId: Number;
  public documentStatus: String = 'Pending Review';
  public scac: String = '';
  public businessType: String = '';
  public updateId: Number;
  public updateProgram: String = '';
  public updatedBy: String = '';
  public currentVersion: Number = 0;
  public approvalComments: String = ''
}
